import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./QuestPost.css";
import hljs from "highlight.js/lib/core";
import javascript from "highlight.js/lib/languages/javascript";
import python from "highlight.js/lib/languages/python";
import go from "highlight.js/lib/languages/go";
import bash from "highlight.js/lib/languages/bash";
import css from "highlight.js/lib/languages/css";
import json from "highlight.js/lib/languages/json";

import "highlight.js/styles/github.css";

hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("python", python);
hljs.registerLanguage("go", go);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("css", css);
hljs.registerLanguage("json", json);

// Convert Obsidian wiki-link images ![[image.png]] to standard markdown ![image.png](image.png)
const convertObsidianImages = (markdown) => {
  // Match ![[filename]] or ![[filename|alt text]]
  return markdown.replace(/!\[\[([^\]|]+)(?:\|([^\]]+))?\]\]/g, (match, filename, altText) => {
    const alt = altText || filename;
    return `![${alt}](${filename})`;
  });
};

const QuestPost = ({ file, questData }) => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch(file)
      .then((res) => res.text())
      .then((text) => setContent(convertObsidianImages(text)));
  }, [file]);

  // Syntax highlighting for code blocks
  useEffect(() => {
    document.querySelectorAll("pre code").forEach((block) => {
      hljs.highlightElement(block);
    });
  }, [content]);

  // Custom image renderer to handle relative paths in quest folder
  const basePath = file.substring(0, file.lastIndexOf('/'));

  const components = {
    img: ({ src, alt, ...props }) => {
      // Handle relative image paths
      let imageSrc = src;
      if (src && !src.startsWith('http') && !src.startsWith('/')) {
        imageSrc = `${basePath}/${src}`;
      } else if (src && src.startsWith('/')) {
        imageSrc = process.env.PUBLIC_URL + src;
      }
      return <img src={imageSrc} alt={alt} {...props} />;
    }
  };

  return (
    <div className="quest-post-container">
      {questData && (
        <div className="quest-post-header">
          <h1>{questData.title}</h1>
          <div className="quest-post-meta">
            <span className="quest-post-date">{questData.date}</span>
            {questData.status && (
              <span className={`quest-post-status quest-status-${questData.status}`}>
                {questData.status === "completed" ? "Completed" :
                 questData.status === "in-progress" ? "In Progress" : "Planned"}
              </span>
            )}
          </div>
          {questData.tags && questData.tags.length > 0 && (
            <div className="quest-post-tags">
              {questData.tags.map((tag) => (
                <span key={tag} className="quest-post-tag">{tag}</span>
              ))}
            </div>
          )}
        </div>
      )}
      <article className="quest-markdown">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={components}
        >
          {content}
        </ReactMarkdown>
      </article>
    </div>
  );
};

export default QuestPost;
